import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { getCheckmarkClasses } from '@styles/global/helpers'

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`

export const FlexTabletRow = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  
  @media ${device.tablet}{
    flex-direction: row;
  }
`

export const FlexItemTablet50 = styled.div`
  position: relative;
  @media ${device.tablet}{
    flex: 0 1 50%;
  }
  
  ${getCheckmarkClasses()};
  
`